import React  from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {Alert, Button, ControlLabel, FormGroup} from "react-bootstrap";
import Modal from "react-bootstrap/es/Modal";
import FieldGroup from "../FieldGroup";
import PropertyDefinitionSelect from "../reusables/PropertyDefinitionSelect";
import ValueSelect from "../reusables/ValueSelect";
import {savePredefinedText} from "../../redux/actions";
import {CREATE_MODE} from "../constants";
import {SAVED_PREDEFINED_TEXT} from "../../redux/action-types";
import PropTypes from "prop-types";

export const allowedTargetTypesForPredefinedTexts = [
    'AppBundle\\Form\\Type\\CustomTextareaType',
    'AppBundle\\Form\\Type\\TextType'
];

class AddPredefinedText extends React.Component {
    constructor(props) {
        super(props);

        this.state = this.initialState();
    };

    initialState() {
        return {
            customerId: this.props.customerId,
            text: {
                triggerProperty: "",
                triggerValue: "",
                targetProperty: "",
                targetValue: "",
                name: "",
                type: "default",
            },
            selectedTargetProperty: undefined,
            selectedTriggerProperty: undefined,
            validationErrors: []
        }
    }

    componentDidUpdate(prevProps,prevState,prevContext) {
        if(this.props.lastAction.type === SAVED_PREDEFINED_TEXT) {
            let initial = this.initialState();
            this.setState({...initial, showModal: false, validationErrors: []})
        }
    }

    targetPropertyChanged(pd) {
        let selectValues = Object.keys(pd.possibleValues);
        this.setState({
            text: {...this.state.text,
                targetProperty: pd.id,
                targetValue:  selectValues.length > 0 ? selectValues[0] : this.state.text.targetValue
            },
            selectedTargetProperty: pd
        })
    }

    triggerPropertyChanged(pd) {
        if(pd) {
            let selectValues = Object.keys(pd.possibleValues);
            this.setState({
                text: {...this.state.text,
                    triggerProperty: pd.id,
                    triggerValue: selectValues.length > 0 ? selectValues[0] : this.state.text.triggerValue
                },
                selectedTriggerProperty: pd
            })
        }
        else {
            this.setState({
                text: {...this.state.text,
                    triggerProperty: null,
                    triggerValue: null
                },
                selectedTriggerProperty: null
            })
        }
    }

    validateFieldPresent(field, humanReadableField, errors, text) {
        if(!this.fieldIsPresent(field, text)) {
            errors.push("Missing the "+humanReadableField+".")
        }
    }

    fieldIsPresent(field, text) {
        if(text && field && text[field]) {
            return text[field].trim() !== "";
        }
        else {
            return false
        }
    }

    save(e) {
        e.preventDefault();
        let errors = [];
        let toPost = {...this.state.text};

        this.validateFieldPresent("name", "Name", errors, toPost);

        if(this.fieldIsPresent("triggerProperty", toPost) || !this.props.allowUnconditional) {
            this.validateFieldPresent("triggerProperty", "Trigger property", errors, toPost);
            this.validateFieldPresent("triggerValue", "Trigger value", errors, toPost);
        }   // This has to do with unconditional predefined texts
        else {
           toPost['triggerProperty'] = null;
           toPost['triggerValue'] = null;
        }

        this.validateFieldPresent("targetProperty", "Target property", errors, toPost);
        this.validateFieldPresent("targetValue", "Target value", errors, toPost);

        this.validateFieldPresent("type", "Type", errors, toPost);

        if(errors.length === 0) {
            this.props.dispatch(savePredefinedText({predefinedText: toPost, customerId: this.state.customerId, mode: CREATE_MODE}))
        }
        else {
            this.setState({validationErrors:errors})
        }
    }

    render() { return (
        <div>
            <div onClick={e => this.setState({ showModal: true })}>
                <i className="fas fa-plus"/>
            </div>

            <Modal show={this.state.showModal} onHide={e => this.setState({ showModal: false })}>
                <Modal.Header closeButton>
                    <Modal.Title>Create predefined text</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FieldGroup
                        id="name"
                        type="text"
                        label="Name"
                        onChange={e => this.setState({text: {...this.state.text, name: e.target.value}})}
                        placeholder="London EC1 WY5"
                    />

                    <FormGroup controlId={"trigger-property-control"}>
                        <ControlLabel>Trigger property</ControlLabel>
                        <PropertyDefinitionSelect customerId={this.props.customerId}
                                                  selectedId={this.state.text.triggerProperty}
                                                  displayWhenEmpty={this.props.allowUnconditional ? "Unconditional" : "Choose one"}
                                                  allowEmpty={this.props.allowUnconditional}
                                                  onChange={pd => this.triggerPropertyChanged(pd)}/>
                    </FormGroup>
                    {this.state.selectedTriggerProperty &&
                    <ValueSelect propertyDefinition={this.state.selectedTriggerProperty}
                                 value={this.state.text.triggerValue}
                                 label="Trigger value"
                                 onChange={v => this.setState({text: {...this.state.text, triggerValue: v}})}/>}


                    <FormGroup controlId={"target-property-control"}>
                        <ControlLabel>Target property</ControlLabel>
                        <PropertyDefinitionSelect customerId={this.props.customerId}
                                                  selectedId={this.state.text.targetProperty}
                                                  displayWhenEmpty={"Choose one"}
                                                  allowPropertyTypes={allowedTargetTypesForPredefinedTexts}
                                                  onChange={pd => this.targetPropertyChanged(pd)}/>
                    </FormGroup>
                    {this.state.selectedTargetProperty && <ValueSelect propertyDefinition={this.state.selectedTargetProperty}
                                 value={this.state.text.targetValue}
                                 label="Target value"
                                 onChange={v => this.setState({text: {...this.state.text, targetValue: v}})}/>}

                    <FieldGroup
                        id="type"
                        type="text"
                        label="Type"
                        value={this.state.text.type}
                        onChange={e => this.setState({text: {...this.state.text, type: e.target.value}})}
                        placeholder="Assign a type, this may be used in the workflow actions."
                    />

                    {this.state.validationErrors && this.state.validationErrors.length > 0 ?
                        <Alert className="pre" bsStyle="danger">
                            {this.state.validationErrors.map(e => <p key={e}>{e}</p>)}
                        </Alert>
                        : null}

                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="primary" onClick={e => this.save(e)}>Save</Button>
                    <Button onClick={e => this.setState({ showModal: false })}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>

    ); };
}

AddPredefinedText.propTypes = {
    customerId: PropTypes.string.isRequired,
    allowUnconditional: PropTypes.bool.isRequired,
};

const mapStateToProps = state => {
    return { pendingCalls: state.pendingCalls, lastAction: state.lastAction,
        propertyDefinitions: state.propertyDefinitions
    };
};

const mapDispatchToProps = (dispatch) => ({dispatch});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddPredefinedText));



// WEBPACK FOOTER //
// ./src/components/predefined-text/AddPredefinedText.js